import { State } from "./State";
import UIController from "../ui/UIController";
import { UIModes, UIStates } from "../ui/UIStates";
import SpinModel from "../model/SpinModel";
import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";

export default class StartFreeSpinsState extends State {
    public enter() {
        super.enter();

        this.startTransitions();
        this.startFreeSpins();

        this.exit();
    }

    protected startFreeSpins() {
        UIController.setState(UIStates.FREE_SPINS);
        SpinModel.enterFreespins();
        UIController.setMode(UIModes.FREE_SPINS);
    }

    protected startTransitions() {
        const reelsFront = ViewManager.getLayer(DefaultLayers.ReelsFront);
        if (reelsFront.hasScene("freespins")) {
            reelsFront.setScene("freespins");
        }

        const background = ViewManager.getLayer(DefaultLayers.Background);
        if (background.hasScene("freespins")) {
            background.setScene("freespins");
        }
    }
}
